import { validEmail } from "../../../../../helpers/utils/formValidations"

export const credentialTypeMap = {
    mobile_ble_nfc: {
        id: 'mobile_ble_nfc',
        name: 'Mobile'
    },
    // apple_wallet: {
    //     id: 'apple_wallet',
    //     name: 'Apple Wallet'
    // },
    // qr: {
    //     id: 'qr',
    //     name: 'QR'
    // }
}

export const cardFormatMap = {
    generic_32_bit: {
        id: 'generic_32_bit',
        name: 'Generic 32 bit'
    }
}

export const validateCredsData = (data = {}, assignmentMethod = 1, qrTypeMap = {}, credentialType) => {
    if (!data?.format) {
        return 'Format cannot be empty.'
    } else if (!data?.email) {
        return 'Email cannot be empty.'
    } else if (!validEmail(data?.email)) {
        return 'Invalid Email'
    } else if (!cardFormatMap[data?.format]) {
        return 'Invalid Card Format'
    } else if (assignmentMethod === 2 && !data?.credential_id) {
        return 'Credential ID cannot be empty'
    } else if (assignmentMethod === 2 && !(/^\d+$/.test(data?.credential_id))) {
        return 'Invalid Credential ID'
    } else if (!data?.name?.trim()) {
        return 'Name cannot be empty.'
    } else if (credentialType === 'qr' && !qrTypeMap[data?.qrType]) {
        return "Invalid QR Type"
    }

    return '-';
}

export const credTypeOptions = [
    { id: "mobile_ble_nfc", name: 'Mobile' },
    { id: "qr", name: 'QR' },
    { id: "apple_wallet_phone", name: 'Apple Wallet (Phone)' },
    { id: "apple_wallet_watch", name: 'Apple Wallet (Watch)' }
]

export const credTypes = [
    { id: "mobile_ble_nfc", name: 'Mobile' },
    { id: "apple_wallet", name: 'Apple Wallet' },
    { id: "qr", name: 'QR' }
]

export const staticQRTypes = [
    { id: 1, name: 'Passthrough QR (Type 1)' },
    { id: 2, name: 'Secure Static QR (Type 2)' },
]

export const dynamicQRTypes = [
    { id: 1, name: 'Secure-Dynamic QR' },
    { id: 2, name: 'Encrypted QR' },
    { id: 3, name: 'Encrypted Device QR' },
    { id: 4, name: 'Badgepass QR' },
]

export const formats = [{ id: 'generic_32_bit', name: 'Generic 32-bit' }]

export const staticQrInfo = [
    {
        title: 'Passthrough QR (Type 1)',
        description: 'A fixed QR code that always contains the same data. It simply “passes through” information to the scanner without additional security or validation. Suitable for general sharing where security is not critical.'
    },
    {
        title: 'Secure Static QR (Type 2)',
        description: 'A fixed QR code with built-in security measures, such as encryption or authentication. While the QR data doesn’t change, only authorized scanners or systems can read or use it, ensuring controlled access.'
    }
]

export const dynamicQrInfo = [
    {
        title: 'Secure Dynamic QR',
        description: 'A QR code that changes over time or is verified in real-time online. It prevents unauthorized reuse or screenshots, ensuring that each scan is valid only for a short period or under specific conditions. Ideal for secure check-ins or temporary access.'
    },
    {
        title: 'Encrypted QR',
        description: 'A QR code containing data that is fully encrypted. Only authorized scanners or apps can decrypt and read the information, making it safe for transmitting sensitive data.'
    },
    {
        title: 'Encrypted Device QR',
        description: 'A QR code whose encrypted data is tied to a specific device. This ensures that the QR can only be used for setup or authentication on the designated device, preventing misuse or cloning.'
    },
    {
        title: 'BadgePass QR',
        description: 'A QR code used as a digital identification badge. It allows individuals to verify their identity or gain access to locations, systems, or events without physical ID cards, providing a secure and convenient digital alternative.'
    }
]

export const detectDuplicateEmails = (data) => {
    const tempData = JSON.parse(JSON.stringify(data));
    const comboMap = {};

    tempData.forEach((entry) => {
        const key = `${entry.email.toLowerCase()}|${entry.credential_type}|${entry.format}`;
        comboMap[key] = (comboMap[key] || 0) + 1;
    });

    tempData.forEach((entry) => {
        const key = `${entry.email.toLowerCase()}|${entry.credential_type}|${entry.format}`;
        if (comboMap[key] > 1) {
            entry.errorMessage = "Duplicate entry: This email is already assigned with the same Credential Type and Format.";
            entry['props'] = { 'data-highlight': 'error' }
        } else if (entry?.errorMessage === "Duplicate entry: This email is already assigned with the same Credential Type and Format.") {
            entry.errorMessage = '-';
            entry['props'] = {}
        }
    });

    return tempData;
}


export const credType1Headers = [
    // {
    //     text: 'Format',
    //     name: 'format',
    // },
    {
        text: 'Email',
        name: 'email',
    },
    {
        text: 'Name',
        name: 'name',
    },
    {
        text: 'QR Type',
        name: 'qrType',
    },
];

export const credType2Headers = [
    // {
    //     text: 'Format',
    //     name: 'format',
    // },
    {
        text: 'Email',
        name: 'email',
    },
    {
        text: 'Name',
        name: 'name',
    },
    {
        text: 'Credential ID',
        name: 'credential_id',
    },
    {
        text: 'QR Type',
        name: 'qrType',
    },
];